import { render, staticRenderFns } from "./ArtistDialog.vue?vue&type=template&id=4048634e&scoped=true"
import script from "./ArtistDialog.vue?vue&type=script&lang=js"
export * from "./ArtistDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtistDialog.vue?vue&type=style&index=0&id=4048634e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048634e",
  null
  
)

export default component.exports